import { render, staticRenderFns } from "./ConfigurationSegment.vue?vue&type=template&id=64f72ef0&scoped=true&"
import script from "./ConfigurationSegment.vue?vue&type=script&lang=ts&"
export * from "./ConfigurationSegment.vue?vue&type=script&lang=ts&"
import style0 from "./ConfigurationSegment.vue?vue&type=style&index=0&id=64f72ef0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64f72ef0",
  null
  
)

export default component.exports